module.exports = function() {
  return new Worker(__webpack_public_path__ + "13f57d292240ee51354b.worker.js");
};